/**
 * What each participant is doing, in the words of the "In this Project" panel (components/workspace/
 * InThisProjectPanel.jsx): "Typing · StoreMap.jsx:11", "Preview · /stores?city=Milano", "Writing useNearby.js,
 * StoreMap.jsx · lines 18–21 · step 4 of 7 · Gemini 2.5 Pro". Fields an older vfs-service does not send are left out.
 */
import { activityOf, agentLinesIn, agentStepLabel, linesLabel, modelLabel } from './presenceModel';
import { cleanRoute } from './collab3Model';

const base = (path) => String(path || '').split('/').pop();
const latestView = (person) => [...(person?.views || [])].sort((a, b) => (b.at || 0) - (a.at || 0))[0] || null;

export function personDoing(person) {
  const views = person?.views || [];
  const typing = views.find((view) => view.typing && view.path);
  const where = (view) => {
    const line = view.cursor?.path === view.path && Number.isInteger(view.cursor?.line) ? `:${view.cursor.line}` : '';
    return `${base(view.path)}${line}`;
  };
  if (typing) { return `Typing · ${where(typing)}`; }
  const latest = latestView(person);
  if (latest?.kind === 'preview') { return `Preview · ${cleanRoute(latest.route) || '/'}`; }
  if (latest?.kind === 'file' && latest.path) { return `Viewing · ${where(latest)}`; }
  const text = activityOf(person);
  return `${text.charAt(0).toUpperCase()}${text.slice(1)}${person?.state === 'idle' ? ' · idle' : ''}`;
}

export function agentDoing(agent) {
  const paths = agent?.paths || [];
  if (paths.length === 0) { return agent?.preview ? 'Checked the preview' : 'Working'; }
  const ranges = paths.length === 1 ? agentLinesIn(agent, paths[0]) : [];
  return [
    `Writing ${paths.map(base).slice(0, 2).join(', ')}${paths.length > 2 ? ` and ${paths.length - 2} more` : ''}`,
    ranges.length ? linesLabel(ranges) : null,
    agentStepLabel(agent),
    modelLabel(agent.model),
    agent.tool && agent.tool !== agent.label ? agent.tool : null,
  ].filter(Boolean).join(' · ');
}
